import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

class RedirectToEnterpriseMembership extends React.Component<RouteComponentProps> {
  componentDidMount() {
    // @ts-ignore
    if (this._redirected) return;
    // @ts-ignore
    this._redirected = true;
    this.props.history.replace('/book?step=confirm&enterprise_membership=true');
  }

  render() {
    return null;
  }
}

export default withRouter(RedirectToEnterpriseMembership);
